// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__-egIv","shake":"FloatingButton_shake__nUrPF"};